import React from 'react'

export const Tabs = (props) => {
    return (
        <div>
           <nav className="flex flex-row justify-between text-white text-xl mt-12">
               {props.children}
           </nav> 
        </div>
    )
}
